module.exports = __webpack_public_path__ + "img/dsci0005.11f70857.jpg";